import * as Yup from 'yup';

const UpdateProfileSchema = Yup.object().shape({
    name: Yup.string()
        .min(4, 'Too short')
        .max(30, 'Too long')
        .required('Name is required'),
    nric: Yup.string()
        .required('NRIC is required'),
});

export default UpdateProfileSchema;
